import news from '@/api/news'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return news.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store (context, data) {
    return news.store(data)
  },
  update (context, data) {
    return news.update(data)
  },
  uploadFile (context, data) {
    return news.uploadfile(data)
  },
  newImageContent (context, data) {
    return news.newImageContent(data)
  },
  readImage (context, id) {
    return news.readImage(id)
  },
  destroy (context, id) {
    return news.destroy(id)
  },
  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await news.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  sendNotification (context, id) {
    return news.sendNotification(id)
  }
}
